import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import PlainSecondaryCta from 'components/Buttons/PlainSecondaryCta';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const formatPhone = (phone = '') =>
  phone.replace(
    /(\d{3})(\d{3})(\d{4})/gi,
    (match, p1, p2, p3) => `(${p1}) ${p2}-${p3}`
  );

const PhoneAnchorLabel = styled(Typography, {
  shouldForwardProp: muiPropForwarding('ownState')
})(({ theme, ownState }) => {
  const ownTextState = ownState?.text?.(theme) ?? {};

  return {
    ...ownTextState,
    padding: '4px'
  };
});

const PhoneAnchor = ({ number, countryCode, dataTestId, LabelProps = {} }) => {
  const { ownState = {}, variant = 'body1' } = LabelProps;

  return (
    <PlainSecondaryCta
      label={
        <PhoneAnchorLabel ownState={ownState} variant={variant}>
          {formatPhone(number)}
        </PhoneAnchorLabel>
      }
      component="a"
      href={`tel:${countryCode}-${number}`}
      dataTestId={dataTestId}
    />
  );
};

PhoneAnchor.propTypes = {
  number: PropTypes.string,
  countryCode: PropTypes.number,
  dataTestId: PropTypes.string,
  LabelProps: PropTypes.object
};

PhoneAnchor.defaultProps = {
  countryCode: 1
};
export default PhoneAnchor;
